import React from "react"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { Document } from "@contentful/rich-text-types"

interface Props {
  node: {
    json: Document
  }
}

// https://www.contentful.com/developers/docs/tutorials/general/rich-text-and-gatsby/

const RichText: React.FC<Props> = ({ node }) => <>{documentToReactComponents(node.json)}</>

export default RichText
